import { Alert, Button, message, Statistic, QRCode, Result, Tabs } from "antd";
import { CarComponent } from "..";
import dayjs from "dayjs";
import { useEffect, useState, useRef } from "react";
import { QPAY_INVOICE, TERMINAL_ID, BANKS } from "../../utils";
const { Countdown } = Statistic;

const Index = (props) => {
  const { collect } = props;
  const [loading, setLoading] = useState(false);
  const triggerTime = useRef(null);
  const [paid, setPaid] = useState(false);
  useEffect(() => {
    setLoading(true);
    let tmp = QPAY_INVOICE;
    tmp.invoice.amount = collect?.time?.amount;
    tmp.invoice.description = `order${collect?.orderdata?.id}`;
    props
      .request({
        url: `/api/qpay/create`,
        method: "POST",
        body: tmp,
        mode: "payment",
      })
      .then((res) => {
        setLoading(false);
        if (res.success) {
          props?.setCollect({ ...collect, invoice: res?.data });
        } else {
          message.error(res.message);
        }
      });
  }, []);

  const handleCancel = () => {
    props?.setCollect({ ...collect, invoice: null });
    props?.setStep(props?.step - 1);
  };

  const finishCountdown = () => {
    handleCancel();
  };

  const onChangeTimer = (value) => {
    if (value <= 0) return;

    const remainingSeconds = Math.floor(value / 1000);

    if (triggerTime.current === null) {
      triggerTime.current = remainingSeconds;
      return;
    }

    const secondsPassed = triggerTime.current - remainingSeconds;
    if (secondsPassed >= 3) {
      if (collect?.invoice) {
        props
          .request({
            url: `/api/qpay/check`,
            method: "POST",
            body: {
              check: {
                invoice_id: collect?.invoice?.id,
                terminal_id: TERMINAL_ID,
              },
            },
            mode: "payment",
          })
          .then((res) => {
            if (res.success) {
              if (res.data && res.data.invoice_status === "PAID") {
                message.success(res.message);
                setPaid(true);
              }
            }
          });
      }
      triggerTime.current = remainingSeconds;
    }
  };

  const handleReset = () => {
    props?.setCollect(null);
    props?.setStep(0);
  };

  const handleDeepLink = (link) => {
    if (collect?.invoice?.qr_code) {
      window.location.href = `${link}${collect?.invoice?.qr_code}`;
      //window?.open(`${link}${collect?.invoice?.qr_code}`, "_blank");
    }
  };

  const renderInvoice = () => {
    if (paid) {
      return (
        <Result
          status="success"
          title={
            <span style={{ fontSize: "1rem" }}>
              Таны цаг захиалга амжилттай хийгдлээ.
            </span>
          }
          subTitle={
            <span className="text-xs">{`Таны захиалгын дугаар №${collect?.orderdata?.id}`}</span>
          }
          extra={[
            <Button type="primary" key="console" onClick={handleReset}>
              Дахин эхлэх
            </Button>,
            <Button>Захиалгын түүх харах</Button>,
          ]}
        />
      );
    }

    if (collect?.invoice) {
      return (
        <div className="flex items-center flex-col justify-center py-5 gap-2">
          <Countdown
            value={Date.now() + 300 * 1000}
            format="mm:ss"
            onChange={onChangeTimer}
            valueStyle={{
              fontSize: "1rem",
              color: "red",
            }}
            onFinish={finishCountdown}
          />
          {collect?.invoice?.qr_code ? (
            <div>
              <QRCode
                value={collect?.invoice?.qr_code}
                size={140}
                bordered={false}
              />
              <span className="mt-2 text-center block">
                Төлөх дүн:{" "}
                <span className="font-bold text-primary">
                  {new Intl.NumberFormat().format(collect?.time?.amount || 0)}
                </span>
              </span>
            </div>
          ) : null}
          <div className=" grid-cols-2 gap-2 grid lg:hidden">
            {BANKS?.map((item, i) => (
              <Button
                key={i}
                className="text-wrap h-full flex justify-start"
                onClick={() => handleDeepLink(item?.link)}
                icon={<img src={item.logo} className="w-5 h-5 rounded-md" />}
              >
                {item?.name}
              </Button>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  const renderInfos = () => {
    return (
      <div className="flex flex-col gap-3">
        <div className="bg-infobg p-3 rounded-md flex flex-col gap-2 shadow shadow-lg">
          <span className="pb-4">Сонгосон төхөөрөмж</span>
          <div className="flex items-center justify-between">
            <span>Нэр</span>
            <span className="font-bold">{collect?.service?.name}</span>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-xs text-black/60">
              {collect?.service?.description}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Суулгах хугацаа</span>
            <span className="font-bold">{`${collect?.service?.hour} цаг`}</span>
          </div>
          <div className="flex items-center justify-between">
            <span>Танилцуулга</span>
            <Button type="link" className="p-0 text-xs">
              Харах
            </Button>
          </div>
        </div>
        <div className="bg-infobg p-3 rounded-md flex flex-col gap-2 shadow shadow-lg">
          <span className="pb-4">Сонгосон огноо</span>
          <div className="flex items-center justify-between">
            <span>Огноо</span>
            <span className="font-bold">
              {dayjs(collect?.time?.date)?.format("YYYY-MM-DD")}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Цаг</span>
            <span className="font-bold">{`${collect?.time?.time}`}</span>
          </div>
        </div>
        <CarComponent data={collect?.info} isPayment={true} />
      </div>
    );
  };

  const renderInvoiceContainer = () => {
    return (
      <div className="">
        <Alert
          type="info"
          message="Та урьдчилгаа төлбөрөө төлснөөр захиалга баталгаажиж мессеж очих болно."
          showIcon
        />
        <div>{renderInvoice()}</div>
        {paid ? null : (
          <div className="flex items-center justify-center mt-4">
            <Button loading={loading} onClick={handleCancel}>
              {collect?.invoice ? "Цуцлах" : "Буцах"}
            </Button>
          </div>
        )}
      </div>
    );
  };

  const items = [
    {
      key: "1",
      label: "Төлбөрийн мэдээлэл",
      children: renderInvoiceContainer(),
    },
    {
      key: "2",
      label: "Машины мэдээлэл",
      children: renderInfos(),
    },
  ];

  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full lg:w-4/6 mb-3 hidden lg:flex">
        <span>Машины мэдээлэл</span>
      </div>
      <div className="w-full block lg:hidden">
        <Tabs defaultActiveKey="1" items={items} />
      </div>
      <div className="w-full lg:w-4/6 grid-cols-2 gap-5 text-sm hidden lg:grid">
        {items[1]?.children}
        {items[0]?.children}
      </div>
    </div>
  );
};

export default Index;
